import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthServiceService } from './auth-service.service';
import { ServiceService } from '../service.service';
import { EncryptionService } from './encryption/encryption.service';

@Injectable()
export class LoginInterceptorInterceptor implements HttpInterceptor {

  // Constructor to inject Router, AuthServiceService, ServiceService, and EncryptionService
  constructor(
    private router: Router,
    private apiService: AuthServiceService,
    private service: ServiceService,
    private encryptionService: EncryptionService
  ) {}

  /**
   * Intercepts HTTP requests to add an Authorization header if the user is authenticated.
   * 
   * @param request - The outgoing HTTP request.
   * @param next - The next handler in the chain.
   * @returns An observable of the HTTP event.
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Retrieve the encrypted token from local storage
    let uidToken = localStorage.getItem('uidToken') || '';

    // Check if the request URL is not the login endpoint and the token exists
    if (uidToken && !request.url.includes('/login')) {
      // Decrypt the token
      uidToken = this.encryptionService.decrypt(uidToken);

      // Clone the request and add the Authorization header
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${uidToken}`
        }
      });
      // console.log('request', request);
    }

    // Handle the request and catch any errors
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Check if the error status is 401 (Unauthorized) and the error message is 'Invalid Token'
        if (error.status === 401) {
          // Show a toast message indicating the session is not found
          this.service.showToast('error', 'Session not Found! Please login again');
          // Log out the user
          this.apiService.logout();
        }
        else if (error.status === 0) {
          // Show a toast message indicating the session is not found
          this.service.showToast('error', 'Session not Found! Please login again');
          // Log out the user
          this.apiService.logout();
        }
        // Return the error as an observable
        return throwError(error);
      })
    );
  }
}